import React from 'react';
import { FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Select, TextFieldProps } from '@material-ui/core';
import { useStyles } from './SessionsCopyDialog.styles';
import { CheckboxOne } from '../../../components/CheckboxOne/CheckboxOne.component';
import { BasicDataFormSessionInfo } from './BasicDataFormSessionInfo.component';
import SelectItemsLoader from '../../../components/SelectItemsLoader.component';
import { ExamSessionSimpleDto } from '../../../models/examSessionDto.types';

interface BasicDataFormProps {
  nop?: string;
  textInputRef: React.MutableRefObject<TextFieldProps | undefined>;
  name: string;
  validName: boolean;
  isTrainingSession: boolean;
  handleIsTrainingSession: (val: boolean) => void;
  type: string;
  year: number;
  month: number;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  useExistingSession: boolean;
  handleUseExistingSessionChange: () => void;
  availableSessions: ExamSessionSimpleDto[];
  selectedSession: ExamSessionSimpleDto | null;
  setSelectedSession: (newSelected: string | null) => void;
}

export const BasicDataForm: React.FC<BasicDataFormProps> = ({
  textInputRef,
  validName,
  name,
  isTrainingSession,
  handleIsTrainingSession,
  type,
  year,
  month,
  handleChange,
  useExistingSession,
  handleUseExistingSessionChange,
  availableSessions,
  selectedSession,
  setSelectedSession,
}: BasicDataFormProps) => {
  const classes = useStyles();

  return (
    <>
      <Grid xs={12} container item style={{ justifyContent: 'center', marginTop: '10px' }}>
        <FormControlLabel
          control={
            <CheckboxOne
              name="Użyj istniejącej sesji egzaminacyjnej"
              onClick={() => {
                handleUseExistingSessionChange();
              }}
              checked={useExistingSession}
            />
          }
          label="Użyj istniejącej sesji egzaminacyjnej"
        />
      </Grid>
      {useExistingSession && (
        <Grid container style={{ justifyContent: 'center', margin: '12px 0px' }}>
          <FormControl variant="outlined" className={`${classes.formInput} ${classes.formInputWidth}`}>
            <InputLabel id="session-select">Sesja egzaminacyjna</InputLabel>
            <Select
              name={selectedSession?.name ?? ''}
              onChange={(e) => setSelectedSession(e.target.value as string)}
              labelId="session-select"
              label="Sesja egzaminacyjna"
              defaultValue={''}
            >
              {availableSessions.length === 0 && <SelectItemsLoader />}
              {availableSessions.map((session: ExamSessionSimpleDto) => (
                <MenuItem disableRipple className={classes.menuItem} key={session.id} value={session.id}>
                  {session.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      )}
      {!useExistingSession && (
        <BasicDataFormSessionInfo
          textInputRef={textInputRef}
          name={name}
          validName={validName}
          isTrainingSession={isTrainingSession}
          handleIsTrainingSession={handleIsTrainingSession}
          type={type}
          year={year}
          month={month}
          handleChange={handleChange}
        />
      )}
    </>
  );
};
